module.exports = __webpack_public_path__ + "static/media/GDB.28f325d2.png";